import React, { useEffect, useState } from 'react';
import axios from 'axios';
import EmptyState from '../../components/emptyState/emptyState.index';
import Button from '../../components/button/button.index';
import MovieCard from '../../components/movieCard/movieCard.index';
import { connect, ConnectedProps } from 'react-redux';
import { ReduxState } from '../../redux/interface';
import { makeApiUrl, responseValidator } from '../../scripts/functions';
import { errorMessages, WOMAPI } from '../WOM.api';
import { MovieType } from '../WOM.interface';
import { useHistory, useLocation, useParams } from 'react-router';
import { toast } from 'react-toastify';
import { getPagination } from '../../redux/actions';
import './movieList.style.scss';

const MovieList: React.FC<ConnectedProps<typeof connector>> = (
    props: ConnectedProps<typeof connector>
) => {
    const [movies, setMovies] = useState<MovieType[] | undefined>(undefined);
    const [totalPages, setTotalPages] = useState<number>(0);
    const history = useHistory();
    const location = useLocation();
    const params: { type: string } = useParams();

    const getGenreIdByName = (name: string): number | undefined => {
        if (props.genrse) {
            return props.genrse.find((genre) => genre.name === name)?.id;
        }
    };

    const handlePagination = (page: number) => {
        props.dispatch(
            getPagination({
                page,
            })
        );
        history.push('?page=' + page);
    };

    useEffect(() => {
        if (props.genrse) {
            setMovies(undefined);
            let apiUrl;
            const page = new URLSearchParams(location.search).get('page');
            page && props.dispatch(getPagination({ page: Number(page) }));
            if (props.filters.query) {
                apiUrl = WOMAPI.search;
            } else if (params.type === 'top_rated') {
                apiUrl = WOMAPI.top_rated;
            } else if (params.type === 'upcoming') {
                apiUrl = WOMAPI.upcoming;
            } else {
                apiUrl = WOMAPI.discover;
            }
            axios.get(makeApiUrl(apiUrl), {
                params: {
                    with_genres: getGenreIdByName(params.type),
                    page: page ? page : 1,
                    query: props.filters.query,
                },
            }).then((response) => {
                if (responseValidator(response)) {
                    setMovies(response.data.results);
                    setTotalPages(response.data.total_pages);
                } else {
                    toast.error(errorMessages.APIError);
                }
            }).catch(() => {
                toast.error(errorMessages.APIError);
            });
        }
    }, [props.filters, history.location, props.genrse]);

    return (
        <div className="wom-movie-list">
            <div className="header">
                <h3>
                    {props.filters.query ? `Results for ${props.filters.query}` : params.type ? params.type.replace('_', ' ').toUpperCase() : 'Popular'.toUpperCase()}
                </h3>
            </div>
            <div className="body">
                {movies ? (
                    <div className="movies">
                        {movies.length ? (
                            movies.map((movie: MovieType) => (
                                <MovieCard key={movie.id} movie={movie} />
                            ))
                        ) : (
                            <EmptyState />
                        )}
                        <div className="grid-protector"></div>
                        <div className="grid-protector"></div>
                        <div className="grid-protector"></div>
                        <div className="grid-protector"></div>
                        <div className="grid-protector"></div>
                        <div className="grid-protector"></div>
                    </div>
                ) : (
                    <div className="movie-loader">
                        <div className="loader">Loading ...</div>
                    </div>
                )}
                {movies && movies.length ? (
                    <div className="movies-pagination">
                        <Button
                            style={props.pagination.page === 1 ? { visibility: 'hidden',}: {}}
                            onClick={() => handlePagination(props.pagination.page - 1)}
                        >
                            Page {props.pagination.page - 1}
                        </Button>
                        <Button
                            style={props.pagination.page === totalPages ? {visibility: 'hidden',}: {}}
                            onClick={() => handlePagination(props.pagination.page + 1)}
                        >
                            Page {props.pagination.page + 1}
                        </Button>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => {
    return {
        genrse: state.genrse,
        filters: state.filters,
        pagination: state.pagination,
    };
};

const connector = connect(mapStateToProps);
export default connector(MovieList);
